<template>
	<div
		class="view view-content"
		ref="top"
	>
		<banner />

		<breadcrumb
			v-if="previousRoute.name"
			label="Back to topic"
		/>

		<div
			v-if="content"
			class="main-content main-content--max-width"
		>
			<div
				v-if="topics.length > 0"
				class="pre-title"
			>
				{{ topics[0].title }}
			</div>

			<h1 class="content-title">{{ content.title }}</h1>

			<hr class="hr--small" />

			<div class="introduction">
				{{ content.excerpt }}
			</div>

			<render-area
				v-if="content.content"
				:value="parsedContent"
			/>

			<share-page
				:title="content.title"
			/>

			<div class="breadcrumb-top-container">
				<breadcrumb
					v-if="previousRoute.name"
					label="Back to topic"
				/>

				<button
					v-if="content.content"
					@click="scrollToTop"
					type="button"
					class="btn--no-style btn-to-top"
				>
					<div class="btn-to-top__icon">
						<svg svg-inline="" focusable="false" role="presentation" width="10" height="7" viewBox="0 0 10 7" xmlns="http://www.w3.org/2000/svg"><g fill="#FFF"><path d="M5.463 1.13c.393.392.471.836.196 1.11L4.287 3.615l-.916.915L2 5.902c-.275.274-.72.196-1.112-.196-.392-.393-.47-.837-.196-1.112l1.373-1.373.915-.915L4.352.933c.275-.274.72-.196 1.111.196z"/><path d="M4.524 1.13c-.393.392-.471.836-.196 1.11L5.7 3.615l.916.915 1.373 1.373c.274.274.719.196 1.11-.196.393-.393.471-.837.197-1.112L7.923 3.221l-.915-.915L5.635.933C5.36.66 4.915.737 4.524 1.13z"/></g></svg>
					</div>
					<div class="btn-to-top__text">Top</div>
				</button>
			</div>

		</div>

		<div class="action-container">
			<div class="container">
				<button
					type="button"
					@click="$store.commit('modalVisible', { modal: 'chooseTopic', boolean: true })"
					class="btn--tertiary btn--full btn--tall btn--centered"
				>
					View a different topic
				</button>
			</div>
		</div>

		<div v-if="content" class="footer-cta footer-cta--sticky">
			<div class="container">
				<button
					v-if="!$store.state.savedContent.includes(content.id)"
					@click="addSave([content.id])"
					type="button"
					class="btn btn--icon btn--icon-reverse btn--icon-add-saved btn--full btn--centered"
				>
					<span>Add to My Saved Info</span>
					<svg svg-inline="" focusable="false" role="presentation" height="141.732" viewBox="-1.23 -8.789 141.732 141.732" width="141.732" xmlns="http://www.w3.org/2000/svg"><path fill="#737a85" d="M139.273 49.088c0-3.284-2.75-5.949-6.146-5.949-.219 0-.434.012-.646.031l-42.445-1.001-14.5-37.854C74.805 1.824 72.443 0 69.637 0c-2.809 0-5.168 1.824-5.902 4.315L49.232 42.169 6.789 43.17a6.606 6.606 0 0 0-.646-.031C2.75 43.136 0 45.802 0 49.088c0 2.1 1.121 3.938 2.812 4.997l33.807 23.9-12.063 37.494a5.728 5.728 0 0 0-.688 2.723c0 3.287 2.75 5.952 6.146 5.952a6.236 6.236 0 0 0 3.812-1.29l35.814-22.737 35.812 22.737a6.236 6.236 0 0 0 3.812 1.29c3.393 0 6.143-2.665 6.143-5.952 0-.979-.25-1.906-.688-2.723l-12.062-37.494 33.806-23.9c1.687-1.061 2.81-2.9 2.81-4.997"/></svg>
				</button>
				<button
					v-else
					@click="removeSave([content.id])"
					type="button"
					class="btn btn--icon btn--icon-reverse btn--icon-add-saved btn--full btn--centered saved"
				>
					<span>Remove to My Saved Info</span>
					<svg svg-inline="" focusable="false" role="presentation" height="141.732" viewBox="-1.23 -8.789 141.732 141.732" width="141.732" xmlns="http://www.w3.org/2000/svg"><path fill="#737a85" d="M139.273 49.088c0-3.284-2.75-5.949-6.146-5.949-.219 0-.434.012-.646.031l-42.445-1.001-14.5-37.854C74.805 1.824 72.443 0 69.637 0c-2.809 0-5.168 1.824-5.902 4.315L49.232 42.169 6.789 43.17a6.606 6.606 0 0 0-.646-.031C2.75 43.136 0 45.802 0 49.088c0 2.1 1.121 3.938 2.812 4.997l33.807 23.9-12.063 37.494a5.728 5.728 0 0 0-.688 2.723c0 3.287 2.75 5.952 6.146 5.952a6.236 6.236 0 0 0 3.812-1.29l35.814-22.737 35.812 22.737a6.236 6.236 0 0 0 3.812 1.29c3.393 0 6.143-2.665 6.143-5.952 0-.979-.25-1.906-.688-2.723l-12.062-37.494 33.806-23.9c1.687-1.061 2.81-2.9 2.81-4.997"/></svg>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
// Mixins
import { saves } from '@/mixins/saves.js';
import { previousRoute } from '@/mixins/previousRoute.js';
import { tooltips } from '@/mixins/tooltips.js';

// Styles
import '@/sass/components/_builder-blocks.scss';

// Components
import Banner from '@/components/blocks/Banner.vue';
import Breadcrumb from '@/components/global/Breadcrumb.vue';
import { RenderArea } from 'rd-vue-block-builder';
import SharePage from '@/components/blocks/SharePage.vue';

export default {
	mixins: [saves, previousRoute, tooltips],
	components: {
		Banner,
		Breadcrumb,
		RenderArea,
		SharePage
	},
	data() {
		return {
			content: null,
			parsedContent: null,
			topics: null
		};
	},
	methods: {
		getContent() {
			this.$store.commit('contentLoading', true);
			this.$content
				.single(this.$route.params.slug, {
					include: 'topics'
				})
				.then(response => {
					this.content = response.model;
					this.topics = response.getData().data.topics;

					if (this.content) {
						this.parsedContent = this.$builder.parseAndSetBlocks(this.content.content);
						this.$nextTick(() => {
							this.tooltips();
						});
					}

					this.$store.commit('contentLoading', false);
				})
				.catch(() => {
					this.$store.commit('apiError', true);
					this.$store.commit('contentLoading', false);
				});
		},
		scrollToTop() {
			window.scrollTo(0, 0);
		}
	},
	created() {
		this.getContent();
	}
};
</script>
